// extracted by mini-css-extract-plugin
module.exports = {"loadingBase":"#257E43","text":"styles_text__K8wgH","last":"styles_last__12GZ5"};